import React from 'react';
import { useDeleteCJSeancesBetweenDates } from '../queries/useDeleteCJSeancesBetweenDates';
import SimpleModal from '@teetsh/app/src/components/SimpleModal';
import { useCJEventsLength } from '../queries/useCJSeances';
import { format } from '@teetsh/app/src/utils/time/format';
import { TrashIcon as Trash } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  from: Date;
  to: Date;
  onClose: () => void;
}

export function DeleteWeekWarningModal(props: Props) {
  const { from, to, onClose, isOpen } = props;
  const deleteEvents = useDeleteCJSeancesBetweenDates();
  const eventsLength = useCJEventsLength({
    from: format(from, 'fr-FR'),
    to: format(to, 'fr-FR'),
  });
  const { t } = useTranslation(['common', 'cahierJournal']);
  return (
    <SimpleModal
      isOpen={isOpen}
      title={t('cahierJournal:toolbar.deleteWeek.modal.title')}
      buttonIcon={Trash}
      body={t('cahierJournal:toolbar.deleteWeek.modal.body', {
        count: eventsLength,
      })}
      validateTitle={t('cahierJournal:toolbar.deleteWeek.modal.validate', {
        count: eventsLength,
      })}
      validateAction={() =>
        deleteEvents({
          from: from,
          to: to,
        }).then(onClose)
      }
      closeModalFct={() => onClose()}
    />
  );
}
